/**
 * @fileoverview Agent definition for inspiration-profile-generator-v1.
 *
 * This agent generates a complete PersonDataProfile from a real-world public
 * figure's name, using the model's training knowledge to produce accurate
 * physical attributes, personality traits, and biographical details.
 *
 * @category characters
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'inspiration-profile-generator-v1',
  kind: 'primitive',
  name: 'Inspiration Profile Generator',
  description: 'Generates a complete character inspiration profile from a real-world public figure\'s name, using model knowledge to produce accurate physical attributes, personality, and biographical details.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    lastUpdated: '2026-02',
    taxonomyPath: 'characters.inspiration.generation',
    usedBy: [
      'use-generate-inspiration-profile.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'inspiration-attribute-deriver-v1',
      'personality-matcher-v2',
    ],
  },
};
